var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "modal-header p-4 is-flex is-justify-content-space-between is-align-items-center is-flex-wrap-wrap",
      },
      [
        _vm.currentTransaction.client
          ? _c(
              "div",
              { staticClass: "is-flex is-flex-direction-column" },
              [
                _c(
                  "b-tag",
                  {
                    attrs: {
                      rounded: "",
                      icon: "user",
                      size: "is-small",
                      type: "is-primary is-light",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.currentTransaction.client.name) +
                        " " +
                        _vm._s(_vm.currentTransaction.client.lastName) +
                        " "
                    ),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.formatRut(_vm.currentTransaction.clientIdNumber)
                        )
                      ),
                    ]),
                  ]
                ),
                _c("div", [
                  _vm.currentTransaction.client
                    ? _c("span", { staticClass: "is-size-7" }, [
                        _vm._v(
                          "Id " +
                            _vm._s(_vm.$t("generalWords.transaction")) +
                            ": "
                        ),
                        _c("span", { staticClass: "_id" }, [
                          _vm._v(_vm._s(_vm.currentTransaction._id)),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "is-flex is-flex-direction-column" }, [
          _c("div", { staticClass: "is-flex is-flex-wrap-wrap" }, [
            _c(
              "div",
              { staticClass: "mr-2" },
              [
                _c("b-icon", {
                  attrs: { icon: "calendar-alt", type: "is-primary" },
                }),
                _c(
                  "span",
                  { staticClass: "has-text-weight-semibold is-size-7" },
                  [
                    _vm._v(
                      _vm._s(_vm.formatDate(_vm.currentTransaction.createdAt))
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _c("b-icon", {
                  attrs: { icon: "paper-plane", type: "is-primary" },
                }),
                _c(
                  "span",
                  { staticClass: "has-text-weight-semibold is-size-7" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.providerDictionary[_vm.currentTransaction.provider]
                      )
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
    _c("div", { staticClass: "modal-card-body" }, [
      _c("section", [
        _c("div", { staticClass: "columns is-desktop is-variable is-3" }, [
          _c("div", { staticClass: "column" }, [
            _vm.currentTransaction.client
              ? _c(
                  "div",
                  {
                    staticClass: "validation-module card-item secondary",
                    attrs: { id: "transaction-metadata" },
                  },
                  [
                    _c("div", { staticClass: "modal-transaction-metadata" }, [
                      _c(
                        "div",
                        { staticClass: "transaction-metadata-amounts" },
                        [
                          _c("RelatedTransaction", {
                            attrs: {
                              transaction: _vm.currentTransaction,
                              "payment-providers": _vm.paymentProviders,
                              "display-cancel-button": _vm.displayCancelButton,
                            },
                          }),
                          _vm.$i18n.locale === "cl"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "is-flex is-justify-content-flex-end is-size-7 mx-2",
                                },
                                [
                                  _vm._v(" Valor UF: "),
                                  _c(
                                    "span",
                                    { staticClass: "has-text-weight-semibold" },
                                    [
                                      _vm._v(
                                        "$ " +
                                          _vm._s(
                                            _vm.formatNumber(
                                              _vm.currentTransaction
                                                .secondaryCurrencyFactor
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "column is-two-thirds-desktop is-full" }, [
            _vm.debtDateToggle && ["cl"].includes(_vm.$i18n.locale)
              ? _c(
                  "div",
                  {
                    staticClass: "validation-module",
                    attrs: { id: "change-debt-date" },
                  },
                  [
                    _c("DebtByDate", {
                      attrs: { transaction: _vm.currentTransaction },
                      on: {
                        "updated-transaction": function ($event) {
                          return _vm.$emit("update-transaction", {
                            transaction: $event,
                            index: _vm.currentTransactionIndex,
                          })
                        },
                        "is-loading": function ($event) {
                          _vm.isButtonDisabled = $event
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "validation-module",
                attrs: { id: "bank-statement-details" },
              },
              [
                _c("bank-statement-details", {
                  attrs: {
                    "id-prefix": _vm.currentTransactionId,
                    "current-transaction-amount": _vm.currentTransaction.amount,
                    type: "checkbox",
                    "default-search":
                      _vm.currentTransaction.trustedIdNumbers.map(
                        (trustedId) => trustedId.idNumber
                      ),
                    "bank-entries": _vm.bankEntries,
                    totals: true,
                  },
                  model: {
                    value: _vm.selectedBankEntries,
                    callback: function ($$v) {
                      _vm.selectedBankEntries = $$v
                    },
                    expression: "selectedBankEntries",
                  },
                }),
              ],
              1
            ),
            ["cl"].includes(_vm.$i18n.locale)
              ? _c(
                  "div",
                  {
                    staticClass: "validation-module",
                    attrs: { id: "create-wallet-entry" },
                  },
                  [
                    _c("create-wallet-entry", {
                      attrs: { transaction: _vm.currentTransaction },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.suggestibleTrustedIdNumbers.length &&
            ["cl"].includes(_vm.$i18n.locale)
              ? _c(
                  "div",
                  {
                    staticClass: "validation-module",
                    attrs: { id: "trusted-id-numbers" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "validation-card card-item secondary" },
                      [
                        _c("h5", { staticClass: "is-size-5" }, [
                          _vm._v("Agregar ruts de confianza"),
                        ]),
                        _vm._l(
                          _vm.suggestibleTrustedIdNumbers,
                          function (suggestible) {
                            return _c(
                              "div",
                              {
                                key: suggestible.idNumber,
                                staticClass: "bank-entries",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.suggestTrustedIdNumbers,
                                      expression: "suggestTrustedIdNumbers",
                                    },
                                  ],
                                  attrs: {
                                    id: `suggestible-${suggestible.idNumber}`,
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    value: suggestible,
                                    checked: Array.isArray(
                                      _vm.suggestTrustedIdNumbers
                                    )
                                      ? _vm._i(
                                          _vm.suggestTrustedIdNumbers,
                                          suggestible
                                        ) > -1
                                      : _vm.suggestTrustedIdNumbers,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.suggestTrustedIdNumbers,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = suggestible,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.suggestTrustedIdNumbers =
                                              $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.suggestTrustedIdNumbers = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.suggestTrustedIdNumbers = $$c
                                      }
                                    },
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "pl-2",
                                    attrs: {
                                      for: `suggestible-${suggestible.idNumber}`,
                                    },
                                  },
                                  [_vm._v(_vm._s(suggestible.idNumber))]
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
            _vm.currentTransaction.status === "PENDING"
              ? _c(
                  "div",
                  {
                    staticClass: "validation-module",
                    attrs: { id: "provider-selection" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "validation-card card-item secondary" },
                      [
                        _c("h5", { staticClass: "is-size-5" }, [
                          _vm._v(
                            _vm._s(
                              `${_vm.$t("generalWords.Select")} ${_vm.$t(
                                "generalWords.Provider"
                              )}`
                            )
                          ),
                        ]),
                        _c(
                          "b-select",
                          {
                            attrs: {
                              id: "provider-select",
                              rounded: "",
                              size: "is-small",
                            },
                            model: {
                              value: _vm.provider,
                              callback: function ($$v) {
                                _vm.provider = $$v
                              },
                              expression: "provider",
                            },
                          },
                          _vm._l(
                            _vm.providerOptions,
                            function (providerOption) {
                              return _c(
                                "option",
                                {
                                  key: `option-${providerOption}`,
                                  domProps: { value: providerOption },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.providerDictionary[providerOption]
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "validation-module",
                attrs: { id: "add-validation-comment" },
              },
              [
                _c(
                  "div",
                  { staticClass: "validation-card card-item secondary" },
                  [
                    _c("h5", { staticClass: "is-size-5" }, [
                      _vm._v(_vm._s(_vm.$t("generalWords.Comment"))),
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.comment,
                            expression: "comment",
                          },
                        ],
                        staticClass: "input is-small input-comments",
                        attrs: { id: "text-input-comment", type: "text" },
                        domProps: { value: _vm.comment },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.comment = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]
                ),
              ]
            ),
            _c("div", { staticClass: "transaction-buttons has-text-right" }, [
              _c(
                "button",
                {
                  staticClass: "button is-button-secondary is-rounded mr-5",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("is-single-process-open", false)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("generalWords.GoBack")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "button is-button-primary is-rounded",
                  attrs: {
                    id: "button-process",
                    disabled: !_vm.checkUserFeature(
                      "element.transaction-approval.button.process"
                    ),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.processTransaction(_vm.currentTransactionId)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("generalWords.Process")) + " ")]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm.errorText
        ? _c("p", { staticClass: "help is-danger" }, [
            _vm._v(" " + _vm._s(_vm.errorText) + " "),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }